import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function extractCity(address: string): string {
  // Extract city from address format: "via e n., paese, salento" -> "paese"
  const parts = address.split(',').map(part => part.trim());
  // Return the second-to-last part (the city) if there are multiple parts
  // Otherwise return the whole address
  if (parts.length >= 2) {
    return parts[parts.length - 2];
  }
  return address;
}
